// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #faf9f6
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* react-select v5: the styles.input function targets the wrapper div, not the
   inner <input> itself. Chrome/Firefox :focus-visible can still show a blue
   rectangle on the native input. This rule suppresses it without affecting
   the custom focus ring we draw on the control container. */
[data-value] > input:focus,
[data-value] > input:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

/* ── Accessibility (Section 508 / WCAG 2.1 AA) ───────────────────────────────
   Visible keyboard focus indicator on every interactive element (2.4.7). Scoped
   to focusable controls so it never paints on non-interactive nodes. Uses the
   AA brand blue (#1565C0) with an offset so it reads on both light and dark
   surfaces. */
a:focus-visible,
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible,
[tabindex]:focus-visible,
[role="button"]:focus-visible,
[role="tab"]:focus-visible,
[role="link"]:focus-visible,
[contenteditable="true"]:focus-visible {
  outline: 3px solid #1565C0;
  outline-offset: 2px;
  border-radius: 2px;
}

/* Skip-to-content link — visually hidden until it receives keyboard focus, then
   slides into view at the top-left so keyboard/screen-reader users can bypass
   the nav (2.4.1 Bypass Blocks). */
.cp-skip-link {
  position: absolute;
  left: 8px;
  top: -56px;
  z-index: 100000;
  background: #1565C0;
  color: #ffffff;
  padding: 10px 16px;
  border-radius: 0 0 8px 8px;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  transition: top 0.15s ease-in-out;
}
.cp-skip-link:focus {
  top: 0;
  outline: 3px solid #0d2c5c;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC;AACF;;AAEA;EACE;aACW;AACb;;AAEA;;;4DAG4D;AAC5D;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;;cAIc;AACd;;;;;;;;;;EAUE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;mCAEmC;AACnC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,MAAM;EACN,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #faf9f6\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* react-select v5: the styles.input function targets the wrapper div, not the\n   inner <input> itself. Chrome/Firefox :focus-visible can still show a blue\n   rectangle on the native input. This rule suppresses it without affecting\n   the custom focus ring we draw on the control container. */\n[data-value] > input:focus,\n[data-value] > input:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n/* ── Accessibility (Section 508 / WCAG 2.1 AA) ───────────────────────────────\n   Visible keyboard focus indicator on every interactive element (2.4.7). Scoped\n   to focusable controls so it never paints on non-interactive nodes. Uses the\n   AA brand blue (#1565C0) with an offset so it reads on both light and dark\n   surfaces. */\na:focus-visible,\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible,\n[tabindex]:focus-visible,\n[role=\"button\"]:focus-visible,\n[role=\"tab\"]:focus-visible,\n[role=\"link\"]:focus-visible,\n[contenteditable=\"true\"]:focus-visible {\n  outline: 3px solid #1565C0;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n/* Skip-to-content link — visually hidden until it receives keyboard focus, then\n   slides into view at the top-left so keyboard/screen-reader users can bypass\n   the nav (2.4.1 Bypass Blocks). */\n.cp-skip-link {\n  position: absolute;\n  left: 8px;\n  top: -56px;\n  z-index: 100000;\n  background: #1565C0;\n  color: #ffffff;\n  padding: 10px 16px;\n  border-radius: 0 0 8px 8px;\n  font-weight: 700;\n  font-size: 14px;\n  text-decoration: none;\n  transition: top 0.15s ease-in-out;\n}\n.cp-skip-link:focus {\n  top: 0;\n  outline: 3px solid #0d2c5c;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
